module.exports = __webpack_public_path__ + "img/no_avatar.d7b4aa55.png";